export default __webpack_public_path__ + "locales/fr/VersionHistory.json?hash=2d55d4577ea5fcf9d0557ddea0c383fb";